<template>
  <b-field grouped>
    <b-autocomplete
      expanded
      @keydown.native="search"
      v-model="searchValue"
      :placeholder="placeholder || $t('search')"
      :data="filteredDataArray"
      @select="
        option => (
          (selected = option),
          (searchValue = option || searchValue),
          search({ type: 'click' })
        )
      "
      @typing="getAsyncData"
    >
      <!-- <template slot="empty">No results found</template> -->
    </b-autocomplete>
    <p class="control" @click="search">
      <b-icon
        class="search-icon-btn"
        :title="placeholder || $t('search')"
        icon="magnify"
      ></b-icon>
    </p>
  </b-field>
</template>

<script>
import { autoComplete } from "../../services/search";

export default {
  name: "searchInput",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      data: []
    };
  },
  created() {
    this.searchValue = this.value;
  },
  methods: {
    search(e) {
      if (
        this.searchValue !== "" &&
        (e.key === "Enter" || e.type === "click")
      ) {
        this.$emit("input", this.searchValue);
      }
    },
    getAsyncData: function(searchValue) {
      if (searchValue) {
        autoComplete(searchValue).then(items => {
          this.data = items;
        });
      }
    }
  },
  computed: {
    filteredDataArray() {
      return this.data.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.searchValue && this.searchValue.toLowerCase()) >= 0
        );
      });
    }
  }
};
</script>
